import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { ExternalLink } from '@uikit';

import { Campaign } from '@api';

type Props = {
  campaign: Campaign;
};

export const CampaignCard = ({ campaign }: Props) => {
  const hasGuaranteedAlocations = campaign?.guaranteedAllocation;

  const info = [
    {
      title: 'Prize Pool',
      text: <span className="max-sm:text-end font-semibold">{campaign?.prizePool}</span>,
    },
    ...(hasGuaranteedAlocations
      ? [
          {
            title: 'Guaranteed Allocations',
            text: <span className="font-semibold">{campaign?.guaranteedAllocation}</span>,
          },
        ]
      : []),
    {
      title: 'Total Tokens',
      text: <span className="font-semibold">{campaign?.totalTokens}</span>,
    },
    {
      title: 'Token Price',
      text: <span className="font-semibold">{campaign?.totalPrice}</span>,
    },
    {
      title: 'Status',
      text: (
        <span
          className={classNames('font-semibold', {
            'text-green-900': campaign?.status === 'active',
            'text-neutral-300': campaign?.status !== 'active',
          })}
        >
          {campaign?.status.charAt(0).toUpperCase() + campaign?.status.slice(1)}
        </span>
      ),
    },
  ];

  return (
    <div className="flex flex-col xl:flex-row w-full border border-base-border-medium rounded-3xl overflow-hidden">
      <ImageProxy
        src={campaign?.bannerImage}
        width={572}
        height={320}
        quality={80}
        alt={campaign?.bannerImage}
        className="flex-shrink-0 h-auto w-full xl:w-[572px] object-cover"
      />
      <div className="flex flex-col relative size-full p-4 lg:p-6">
        <div className="flex items-center mb-4">
          <ImageProxy
            src={campaign?.logoImage}
            width={48}
            height={48}
            alt={campaign?.logoImage}
            className="absolute -top-6 md:relative md:top-0 !rounded-[25px]"
          />
          <h4 className="text-2xl font-semibold mt-4 md:ml-4 md:mt-0">{campaign?.title}</h4>
        </div>
        <ul className="flex flex-col gap-3 mb-6">
          {info.map(({ title, text }) => (
            <li key={title} className="flex justify-between">
              <span className="text-sm text-neutral-500">{title}</span>
              {text}
            </li>
          ))}
        </ul>
        <ExternalLink
          href={campaign?.link}
          className="ui-button ui-button-solid-primary flex mt-auto h-10 text-sm gap-2"
        >
          {campaign?.buttonLabel}
        </ExternalLink>
      </div>
    </div>
  );
};
